var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"saas-section",class:[
    {
      'saas-section--gray': _vm.block.background === 'gray',
      'saas-section--light-to-dark': _vm.block.background === 'light_to_dark',
      'saas-section--dark-to-light': _vm.block.background === 'dark_to_light',
    },
  ]},[(_vm.block.title)?_c('div',{staticClass:"saas-section__title",class:{ 'saas-section__title--wide': _vm.block.wide }},[_c('h2',{staticClass:"saas-striped-title"},[_vm._v(_vm._s(_vm.block.title))])]):_vm._e(),_vm._v(" "),(_vm.block.text)?_c('div',{staticClass:"saas-section__description"},[_vm._v("\n    "+_vm._s(_vm.block.text)+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.block.contained)?_c('PageIconContainer',{attrs:{"icons":_vm.block.usps}}):_c('PageIconGrid',{attrs:{"icons":_vm.block.usps}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }